import React, { FC, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "Context/AppContext";
import TableSkeletonElement from "Components/GMS/Products/components/TableSkeletonElement";
import CSAttributeMapping from "../components/CSAttributeMapping";
import { CSContext } from "../contexts/CSContext";
import CSConfigHeader from "../components/CSConfigHeader";
import CSSolidLineComponent from "../components/CSSolidLineComponent";
import CSCategorySelection from "../components/CSCategorySelection";
import CSVersionTable from "../components/CSVersionTable";
import CSIdentifierInput from "../components/CSIdentifierInput";
import CompatioLoader from "Components/Common/components/CompatioLoader";
import usePagination from "Components/Common/hooks/usePagination";
import CSTablePagination from "../components/CSTablePagination";
import CSCreateButton from "../components/CSCreateButton";

const ComputedSubstitutionEditComponent: FC = (props: any) => {
  const { params } = props.match;
  const { categoryid: categoryId, uid, mode } = params;
  const appContext = useContext(AppContext);
  const readPermission = appContext.pm.checkPermission("computedsubstitution_read");
  let industryId =
    appContext &&
    appContext?.get_selected_industry() &&
    appContext?.get_selected_industry()?.id;
  const history = useHistory();
  const { loading, pivotDataloading, fetchInitialState, resetState, handleDone, pivotVersionList, getPivotVersions, category } = useContext(CSContext)
  const { totalRecords, handlePageChange, updatePageSize, paginationParams, updateTotalRecords } = usePagination()
  const [selectedIndex, setSelectedIndex] = useState<number>(0);


  useEffect(() => {
    resetState()
    if (!readPermission) {
      history.push("/workspace/module/permission/denied");
      return;
    }
    fetchInitialState(categoryId, uid);
  }, [industryId, categoryId, uid, mode]);

  useEffect(() => {
    if (category)
      getPivotVersions(category, updateTotalRecords, paginationParams)
  }, [paginationParams])

  const doneHandler = () => {
    handleDone(uid, mode)
  }

  return (
    <>
      <CSConfigHeader
        onCLickFunction={doneHandler}
        linkTo="/gms/computed_substitutions"
        label="Computed Substitutions"
        buttonName="Done"
        mode={mode}
        showBackButton={true}
      />
      <CSSolidLineComponent />
      {loading ? (
        <TableSkeletonElement />
      ) : (
          <>            
            <CSCategorySelection id={'category-selection'} categoryId={categoryId} updateTotal={updateTotalRecords} />
            {
              pivotDataloading ? (
                <CompatioLoader />
              ) :
                (mode === "create" && pivotVersionList?.length > 0 ?
                <div className="tw-ml-7">
                    <CSVersionTable
                      selectedIndex={selectedIndex}
                      setSelectedIndex={setSelectedIndex} />
                    {
                      pivotVersionList && pivotVersionList?.length > 0 ?
                        <CSTablePagination
                          paginationParams={paginationParams}
                          totalRecords={totalRecords}
                          updatePageSize={updatePageSize}
                          handlePageChange={handlePageChange} />
                        :
                        null
                    }
                    <CSCreateButton
                      selectedIndex={selectedIndex}
                      setSelectedIndex={setSelectedIndex} />
                  </div>
                : 
                  ["edit", "create_version"].includes(mode) || pivotVersionList?.length == 0 ? 
                    <>
                      <CSIdentifierInput mode={mode} />
                      <CSAttributeMapping />
                    </>
                    :
                    null)
            }
          </>
      )}
    </>
  );
};

export default ComputedSubstitutionEditComponent;
